<template>
    <AdditionalDescription 
        :entity-type="BUSINESS_TYPE.GROCER"
        :entity-id="+$route.params.id">
        <template v-slot:tabs>
            <GrocerTabLinks />
        </template>
    </AdditionalDescription>
</template>

<script>
    import GrocerTabLinks from '@/components/grocers/GrocerTabLinks';
    import AdditionalDescription from '@/components/additional-description/AdditionalDescription';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'GrocerAdditionalDescription',

        components: {
            GrocerTabLinks,
            AdditionalDescription
        },
  
        data () {
            return {
                BUSINESS_TYPE,
            }
        },
    
        computed: {},

        async mounted() {
        },

        methods: {}
    }
</script>
